// extracted by mini-css-extract-plugin
module.exports = {"Select":"Select_Select__1dAEM","label":"Select_label__m03An","select":"Select_select__CwbUb"};